import { makeStub } from "./_base";
export const SalesInvoice = makeStub("SalesInvoice");
